import type { FC } from 'react';

import cypressIds from 'Components/cypress_ids.json';
import { logger } from 'Services/logger/logger';
import type { AccountSlugs } from 'Types/account';
import type { VehicleAccountListItem } from 'Types/vehicle';
import { applyCypressData } from 'Utilities/helpers';

import { TEXT_FALLBACK } from '../../../../AccountPage.consts';
import BidCreatedAtTimer from '../../../../utilities/BidsCreatedAtTimer/BidsCreatedAtTimer';
import { isCompletedPage } from '../../../Purchases.helpers';

type PurchaseBidValueCellProps = Pick<VehicleAccountListItem, 'enquirySoldDate' | 'id'> & {
	createdAt: Date;
	index: number;
	slug: AccountSlugs;
};

const PurchaseBidValueCell: FC<PurchaseBidValueCellProps> = ({ createdAt, enquirySoldDate, id, index, slug }) => {
	const isCompleteSlug = isCompletedPage(slug);

	// Complete slug - enquirySoldDate field is the first choice value, while createAt is the fallback value.
	// Cancelled slug - createdAt is the first choice value.
	// Both slugs - use TEXT_FALLBACK placeholder to fail gracefully.
	const dateFieldValue = isCompleteSlug ? enquirySoldDate || createdAt : createdAt;

	if (isCompleteSlug && !enquirySoldDate) {
		logger.warn({
			message: `Enquiry with id ${id} in the status purchases complete does not have enquirySoldDate field populated.`,
			scope: 'PurchaseBidValueCell',
		});
	}

	return (
		<span
			{...applyCypressData(
				`${
					isCompleteSlug ? cypressIds.accountDataGrid.dataGridFields.won : cypressIds.accountDataGrid.dataGridFields.bid
				}-${index}`,
			)}
		>
			{dateFieldValue ? <BidCreatedAtTimer value={String(dateFieldValue)} /> : TEXT_FALLBACK}
		</span>
	);
};

export { PurchaseBidValueCell };
